var DeployEnv = /* @__PURE__ */ ((DeployEnv2) => {
  DeployEnv2["LOCAL"] = "local";
  DeployEnv2["DEV"] = "dev";
  DeployEnv2["TEST"] = "test";
  DeployEnv2["PROD"] = "prod";
  return DeployEnv2;
})(DeployEnv || {});
var DeployArea = /* @__PURE__ */ ((DeployArea2) => {
  DeployArea2["CN"] = "cn";
  DeployArea2["SG"] = "sg";
  DeployArea2["US"] = "us";
  DeployArea2["EU"] = "eu";
  return DeployArea2;
})(DeployArea || {});
var TiLocale = /* @__PURE__ */ ((TiLocale2) => {
  TiLocale2["ZH_CN"] = "zh-CN";
  TiLocale2["EN_US"] = "en-US";
  TiLocale2["JA_JP"] = "ja-JP";
  return TiLocale2;
})(TiLocale || {});
export {
  DeployArea,
  DeployEnv,
  TiLocale
};
